/**
 * [#186] GET /api/v1/mailboxes — รายชื่อกล่อง (helpdesk mailboxes) สำหรับ from-picker ของ composer
 * ใช้ได้ทุก staff (พนักงานทั่วไป — admin มี /api/v1/admin/mailboxes อยู่แล้ว) · read-only
 * scoping เดียวกับ validation ของ from_mailbox_id ใน ticket send path (#92 · tickets/reply/send.ts):
 * กล่องที่ active เท่านั้น · ฟิลด์กระชับเท่าที่ picker ต้องใช้ — ห้ามเผย config ระดับผู้ดูแล (no over-exposure)
 * self-contained ไม่ import จาก ./index.ts (กัน circular TDZ — แบบเดียวกับ admin.ts)
 */
import { z } from "zod";
import { MailboxAlias } from "./admin.ts";

export const StaffMailbox = z.object({
  id: z.uuid(),
  /** ที่อยู่หลักของกล่อง — ใช้เป็นค่า From เมื่อส่งด้วย from_mailbox_id นี้ */
  address: z.string(),
  display_name: z.string(),
  /** alias ของกล่อง — ใช้จับคู่กับ mail identity ของผู้เรียกเพื่อติดป้าย "คุณส่งได้" */
  aliases: z.array(MailboxAlias),
  /** การ์ดที่ตอบได้ = การ์ดของ service เดียวกับกล่อง (send path ตรวจซ้ำอีกชั้น = 422) */
  service_id: z.uuid(),
});
export type StaffMailbox = z.infer<typeof StaffMailbox>;

export const StaffMailboxList = z.object({ items: z.array(StaffMailbox) });
export type StaffMailboxList = z.infer<typeof StaffMailboxList>;
